import React, { useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";


// A modal/pop-up that appears on subcodon/comparison plot pages when user inputs a gene
const TranscriptChooserModal = ({
  isOpen,
  toggle,
  headers = [],
  rows = [],
  onSelect,
  loading = false,
  title = "Select a transcript",
  transcriptHeaderMatcher = (h) => String(h).toLowerCase().includes("transcript"),
}) => {
  const transcriptColIndex = useMemo(() => {
    if (!headers || headers.length === 0) return -1;
    return headers.findIndex(transcriptHeaderMatcher);
  }, [headers, transcriptHeaderMatcher]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      backdrop="static"
      keyboard={!loading}
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        {transcriptColIndex === -1 && (
          <div className="text-danger small mb-2">
            Couldn’t find a “transcript” column — showing rows anyway.
          </div>
        )}

        <div className="table-responsive" style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <table className="table table-striped table-bordered table-sm align-middle">
            <thead>
              <tr>
                {headers.map((h, i) => (
                  <th key={i} className="text-nowrap">{String(h)}</th>
                ))}
                <th className="text-nowrap">Select transcript</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => <td key={cIdx}>{String(cell)}</td>)}
                  <td>
                    {transcriptColIndex !== -1 ? (
                      // A select button which will choose the transcript on this row to
                      // create the plot, plot will auto gen after selection
                      <Button
                        size="sm"
                        color="primary"
                        disabled={loading}
                        onClick={() => onSelect(row[transcriptColIndex])}
                      >
                        Select
                      </Button>
                    ) : (
                      <span className="text-muted small">N/A</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

export default TranscriptChooserModal;
